import { Link } from '@material-ui/core';
import { Column, Columns, Stack } from '@superdispatch/ui';
import { TextBox } from '@superdispatch/ui-lab';
import { useNavigate } from 'react-router-dom';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { getLoadSuggestionsPageUrl } from 'shared/modules/load-suggestions/getLoadSuggestionsPageUrl';
import styled from 'styled-components';
import { trackDriverOpenedPostingIfSuggested } from '../../core/DriverSuggestedLoadAnalytics';
import { trackLoadboardEvent } from '../../core/LoadboardAnalytics';
import { useLoadboardContext } from '../../data/LoadboardContext';
import { usePostingsCount } from '../../data/LoadboardPostingAPI';
import { SuggestedLoadsSliderLastCard } from './SuggestedLoadsSliderLastCard';
import { SuggestedLoadCard } from './SuggestedLoadCard';
import { PostingDTO } from 'loadboard/data/dto/PostingDTO';

const Wrapper = styled.div`
  overflow-x: auto;
  scroll-snap-type: x mandatory;
`;

const CardsContainer = styled.div`
  display: flex;
  align-items: stretch;
  flex-wrap: nowrap;
  gap: 8px;

  & > * {
    flex-shrink: 0;
  }
`;

type ViewAllSource = 'View All on Available Loads' | 'View All on Map Card';

interface Props {
  suggestedLoads: PostingDTO[];
  headingSize?: 'heading-3' | 'heading-4';
  utmMedium: 'Available Tab' | 'Home Screen Slider';
}

export function SuggestedLoadsSlider({
  suggestedLoads,
  headingSize = 'heading-4',
  utmMedium,
}: Props) {
  const navigate = useNavigate();
  const {
    router: { openPostingScreen },
  } = useLoadboardContext();

  const { data: postingCounts } = usePostingsCount();

  if (suggestedLoads.length === 0) {
    return null;
  }

  const openSuggestedLoadsPage = (utm_medium: ViewAllSource) => {
    trackLoadboardEvent({
      name: 'Driver Opened Suggested Loads',
      utm_medium,
    });
    navigate(getLoadSuggestionsPageUrl({ withLeadingSlash: true }));
  };

  return (
    <Stack>
      <Columns>
        <Column>
          <TextBox variant={headingSize}>Suggested Loads</TextBox>
        </Column>

        <Column width="content">
          <Link
            href="#"
            color="primary"
            onClick={() =>
              openSuggestedLoadsPage('View All on Available Loads')
            }
          >
            View All {postingCounts?.suggested}
          </Link>
        </Column>
      </Columns>

      <Wrapper>
        <CardsContainer>
          {suggestedLoads.slice(0, 5).map((posting) => (
            <SuggestedLoadCard
              key={posting.load.guid}
              posting={posting}
              onClick={() => {
                trackDriverOpenedPostingIfSuggested(
                  posting,
                  utmMedium,
                  'Suggested Loads Slider',
                );
                openPostingScreen(posting, 'push', {
                  utm_medium: 'Suggested Load',
                  utm_content: 'Suggested Loads Slider',
                  ...(MobileAppBridge.isInjected() && {
                    utm_source: 'Driver App',
                  }),
                });
              }}
            />
          ))}

          <SuggestedLoadsSliderLastCard
            onClick={() => openSuggestedLoadsPage('View All on Map Card')}
          />
        </CardsContainer>
      </Wrapper>
    </Stack>
  );
}
